import { getRequest } from 'global/helpers/requests'

const TRIP_PREFIX = 'trip-service'
const DECA_FILENAME = 'deca.pdf'

export const downloadDecaDocument = async (token: string): Promise<Blob> =>
  await getRequest(`/deca/${token}`, {}, TRIP_PREFIX)

export const triggerBlobDownload = (blob: Blob, fileName = DECA_FILENAME): void => {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  document.body.append(anchor)
  anchor.click()
  anchor.remove()
  globalThis.setTimeout(() => URL.revokeObjectURL(url), 1000)
}
